import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { parseISO } from "date-fns";
import {
  getLeadIdHtml,
  getSortingClass,
  getTableStyles,
  getTimeLapsedDiv,
} from "../utils/table";
import { convertToUTCFormat, formatAmount } from "../utils/format";
import {
  disbursementStatusColorCls,
  disbursementSubStatusColorCls,
} from "../utils/constant.js";
import { axios_instance } from "../api/axios_instance.js";
import SingleSelectDropDown from "./SingleSelectDropDown.jsx";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import PaginationButtons from "./PaginationButtons.jsx";
import { encryptRequest } from "../utils/encryptdecryptrequest.js";

const Table = React.memo(
  ({
    activeTab,
    page,
    tabData,
    statuses,
    subStatuses,
    handleSorting,
    sortingColumns,
    prevPage,
    pageSelected,
    nextPage,
    fetchCaseData,
    fetchDisbursementCounts,
  }) => {
    const initialState = {
      typeAssignButton: 1,
      payleadAssignButton: 1,
      assigneeList: [],
      payleadAssigneeList: [],
      selectedAssigneeList: {},
      selectedPayleadAssigneeList: {},
    };

    const [state, setState] = useState(initialState);
    const user = useSelector((state) => state.user);

    const fetchData = useCallback(async () => {
      try {
        let assignButtonResult = await axios_instance({
          url: "/dts/getTypeAssignButton",
          method: "POST",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          data: { activeTab },
        });
        assignButtonResult = assignButtonResult.data.result;
        setState((prevState) => ({
          ...prevState,
          typeAssignButton: assignButtonResult.typeAssignButton,
          payleadAssignButton: assignButtonResult.payleadAssignButton,
          assigneeList: assignButtonResult.assigneeList,
          payleadAssigneeList: assignButtonResult.payleadAssigneeList,
        }));
      } catch (error) {}
    }, [activeTab]);

    useEffect(() => {
      if ([1, 2, 3, 4, 6].includes(activeTab)) fetchData();
    }, [activeTab, fetchData]);

    if (!user) {
      return;
    }

    const assignOrReassignMaker = async (
      lead_id,
      id,
      fcm_bank_id,
      bank_disbursed_amount,
      maker_id = "",
      targetType,
    ) => {
      const type = targetType ? targetType : !id ? 1 : 2;
      if (window.confirm("Are you sure you want to assign?")) {
        try {
          const result = await axios_instance({
            url: `/dts/assignOrReassignMaker`,
            method: "POST",
            data: {
              finance_lead_id: lead_id,
              disbursement_id: id,
              net_disbursement_amount: bank_disbursed_amount,
              stage: 1,
              sub_stage: 2,
              bank_id: fcm_bank_id,
              maker_id,
              type,
            },
          });
          if (result.status === 200) {
            await fetchCaseData();
            window.confirm("Details has been saved successfully");

            fetchDisbursementCounts();
          }
        } catch (error) {}
      }
    };

    const assignPaylead = async (
      finance_lead_id,
      disbursement_id,
      pay_count,
      customer_name,
      last_name,
      regno,
      pay_head_id = "",
      assignAction = "",
    ) => {
      if (window.confirm("Are you sure you want to assign?")) {
        try {
          customer_name = customer_name ? customer_name : "";
          if (last_name) customer_name += last_name;
          const reqData = encryptRequest({
            finance_lead_id,
            disbursement_id,
            stage: 1,
            sub_stage: 6,
            pay_count,
            pay_head_id,
            customer_name,
            regno: regno,
            assignAction,
          });
          const result = await axios_instance({
            url: `/dts/updateReassignPaylead`,
            method: "POST",
            data: { reqData },
          });
          if (result.status === 200) {
            await fetchCaseData();
            window.confirm("Details has been saved successfully");

            fetchDisbursementCounts();
          }
        } catch (error) {}
      }
    };

    const handleAssigneeChange = async (
      e,
      lead_id,
      id,
      fcm_bank_id,
      bank_disbursed_amount,
      type,
    ) => {
      const newValue = e.target.value;
      setState({
        ...state,
        selectedAssigneeList: {
          ...state.selectedAssigneeList,
          [lead_id]: newValue,
        },
      });
      if (!newValue.length || !+newValue) {
        toast.dismiss();
        return toast.error("Please select maker to assign this case", {
          theme: "colored",
        });
      }
      await assignOrReassignMaker(
        lead_id,
        id,
        fcm_bank_id,
        bank_disbursed_amount,
        newValue,
        type,
      );
    };

    const handlePayleadAssigneeChange = async (
      e,
      lead_id,
      disbursement_id,
      pay_count,
      customer_name,
      last_name,
      regno,
      action = "",
    ) => {
      const newValue = e.target.value;
      setState({
        ...state,
        selectedPayleadAssigneeList: {
          ...state.selectedPayleadAssigneeList,
          [lead_id]: newValue,
        },
      });
      if (!newValue.length || !+newValue) {
        toast.dismiss();
        return toast.error("Please select paylead to assign this case", {
          theme: "colored",
        });
      }
      await assignPaylead(
        lead_id,
        disbursement_id,
        pay_count,
        customer_name,
        last_name,
        regno,
        newValue,
        action,
      );
    };
    return (
      <div role="tabpanel" className="tab-pane fade in active" id="cases">
        <div className="table-responsive">
          <div id="case_wrapper" className="dataTables_wrapper no-footer">
            <table
              id="cases"
              className="fmTableview display table table-bordered table-hover dataTable no-footer"
              cellSpacing="0"
              width="100%"
              role="grid"
              aria-describedby="case_info"
            >
              <style>{getTableStyles(activeTab)}</style>
              <thead>
                <tr role="row">
                  <th
                    className={`sorting${getSortingClass(
                      sortingColumns,
                      "lead_id",
                    )} dtslist-lead-id`}
                    aria-controls="dtscase"
                    aria-label="Loan ID: activate to sort column ascending"
                    onClick={() => handleSorting("lead_id")}
                  >
                    Loan ID
                  </th>
                  {[0, 4, 6, 7].includes(activeTab) && (
                    <th
                      className={`sorting${getSortingClass(
                        sortingColumns,
                        "from_date",
                      )} dtslist-timelapsed`}
                      aria-label="Time Lapsed"
                      onClick={() => handleSorting("from_date")}
                    >
                      Tranche Assign Date
                    </th>
                  )}
                  <th
                    className="sorting_disabled dtslist-requested-on"
                    aria-label="Requested-On"
                  >
                    {(() => {
                      switch (activeTab) {
                        case 0:
                          return "Requested-On";
                        case 1:
                        case 3:
                        case 4:
                        case 6:
                        case 7:
                          return "Requested Date";
                        case 2:
                          return "Released Date";
                        case 5:
                          return "Disbursed Date";
                        default:
                          return "Requested On";
                      }
                    })()}
                  </th>
                  <th
                    className={`sorting${getSortingClass(
                      sortingColumns,
                      "cus_name",
                    )} dtslist-customer`}
                    aria-label="Customer: activate to sort column ascending"
                    onClick={() => handleSorting("cus_name")}
                  >
                    {activeTab === 0 ? "Customer" : "Customer Details"}
                  </th>
                  <th
                    className={`sorting${getSortingClass(
                      sortingColumns,
                      "dealer_name",
                    )} dtslist-dealer`}
                    aria-controls="dtscase"
                    aria-label="Dealer: activate to sort column ascending"
                    onClick={() => handleSorting("dealer_name")}
                  >
                    {activeTab === 0 ? "Dealer" : "Dealer Details"}
                  </th>

                  {activeTab === 0 &&
                  tabData.caseData &&
                  tabData.caseData.length &&
                  tabData.caseData[0].hasOwnProperty("payee_type") ? (
                    <th className="">Payee Type</th>
                  ) : (
                    <></>
                  )}

                  <th
                    className={`sorting${getSortingClass(
                      sortingColumns,
                      "city",
                    )} dtslist-city`}
                    aria-controls="dtscase"
                    aria-label="City: activate to sort column ascending"
                    onClick={() => handleSorting("city")}
                  >
                    City
                  </th>

                  {activeTab !== 5 && (
                    <th
                      className={`sorting${getSortingClass(
                        sortingColumns,
                        "stage",
                      )} dtslist-status`}
                      aria-controls="dtscase"
                      aria-label="Status: activate to sort column ascending"
                      onClick={() => handleSorting("stage")}
                    >
                      Status
                    </th>
                  )}

                  {activeTab !== 5 && (
                    <th
                      className="sorting_disabled dtslist-substatus"
                      aria-label="SubStatus"
                    >
                      SubStatus
                    </th>
                  )}

                  {activeTab === 2 && (
                    <th
                      className="sorting_disabled dtslist-balance-amt"
                      aria-label="Balance Amount"
                    >
                      Balance Amt
                    </th>
                  )}

                  {activeTab === 6 && (
                    <th
                      className="sorting_disabled dtslist-assign-to"
                      aria-label="Assign To"
                    >
                      Assign To
                    </th>
                  )}

                  {[0, 1, 6, 7].includes(activeTab) && (
                    <th
                      className="sorting_disabled dtslist-payment-type"
                      aria-label="Payment Type"
                    >
                      Payment Type
                    </th>
                  )}

                  {activeTab === 0 ? (
                    <th className="sorting_disabled dtslist-l0" aria-label="L0">
                      L0
                    </th>
                  ) : [3, 4].includes(activeTab) ? (
                    <th
                      className="sorting_disabled dtslist-l0 all-case-assigned-to"
                      aria-label="Assigned To"
                    >
                      Assigned To
                    </th>
                  ) : (
                    ""
                  )}

                  {[1, 7].includes(activeTab) && (
                    <th
                      className={`sorting${getSortingClass(
                        sortingColumns,
                        "assign_to",
                      )} dtslist-assigned-to`}
                      aria-label="Assigned To"
                      onClick={() => handleSorting("assign_to")}
                    >
                      Assigned To
                    </th>
                  )}

                  {/* {activeTab === 0 ? (
                    <th className="sorting_disabled dtslist-l1" aria-label="L1">
                      L1
                    </th>
                  ) : [2, 3, 4].includes(activeTab) ? (
                    <th
                      className="sorting_disabled dtslist-l1"
                      aria-label="Checked By"
                    >
                      Checked By
                    </th>
                  ) : (
                    ""
                  )} */}

                  {(activeTab === 3 || activeTab === 4) && (
                    <th
                      className="sorting_disabled dtslist-released-cancelled-by"
                      aria-label="Released/Cancelled By"
                    >
                      Released/Cancelled By
                    </th>
                  )}

                  {activeTab === 2 ? (
                    <th
                      className="sorting_disabled dtslist-released-by"
                      aria-label="Released By"
                    >
                      Released By
                    </th>
                  ) : activeTab === 3 || activeTab === 4 ? (
                    <th
                      className="sorting_disabled dtslist-released-by"
                      aria-label="HOD"
                    >
                      HOD
                    </th>
                  ) : (
                    ""
                  )}

                  {activeTab === 2 && (
                    <th
                      className="sorting_disabled dtslist-reassign-to"
                      aria-label="Reassign To"
                    >
                      Reassign To
                    </th>
                  )}

                  {activeTab === 5 && (
                    <th
                      className="sorting_disabled dtslist-net-dis-amt"
                      aria-label="Net Disbursement Amount"
                    >
                      Net Disbursement Amount
                    </th>
                  )}

                  {activeTab === 5 && (
                    <th
                      className="sorting_disabled dtslist-bank-name"
                      aria-label="Bank Name"
                    >
                      Bank Name
                    </th>
                  )}

                  {activeTab === 5 && (
                    <th
                      className="sorting_disabled dtslist-los-id"
                      aria-label="LOS ID"
                    >
                      LOS ID
                    </th>
                  )}

                  {activeTab === 5 && (
                    <th
                      className="sorting_disabled dtslist-loan-type"
                      aria-label="Loan Type"
                    >
                      Loan Type
                    </th>
                  )}

                  <th
                    className="sorting_disabled dtslist-action"
                    aria-label="Action"
                  >
                    Action
                  </th>
                </tr>
                {!tabData.caseData.length ? (
                  <tr className="odd">
                    <td colSpan="24" className="dataTables_empty light_row">
                      No data available in table
                    </td>
                  </tr>
                ) : (
                  ""
                )}
                {tabData.caseData.map((caseObj, index) => {
                  const payment_type =
                    caseObj.float_payment === "1" ? "Float" : "Non-Float";
                  const tranches = `Tranche# ${
                    !caseObj.dts_pay_count ? "0" : caseObj.dts_pay_count
                  }/${
                    !caseObj.total_tu_tranches ? "0" : caseObj.total_tu_tranches
                  }`;

                  const { raised_date, time_lapsed } = getTimeLapsedDiv(
                    activeTab,
                    caseObj.sub_stage,
                    caseObj.timelapsed_startdate,
                    caseObj.timelapsed_enddate,
                  );

                  let stage =
                      !caseObj.stage || statuses.length === 0
                        ? "Payment Requested"
                        : statuses[caseObj.stage - 1]?.label ||
                          "Payment Requested",
                    substage = "Open",
                    statusCls = disbursementStatusColorCls[0],
                    substatusCls = disbursementSubStatusColorCls[8];

                  if (caseObj.stage) {
                    const stageObj = statuses.find(
                      ({ value }) => value === parseInt(caseObj.stage),
                    );
                    stage = stageObj?.label || "Payment Requested";
                    statusCls = disbursementStatusColorCls[caseObj.stage - 1];
                  }

                  if (caseObj.sub_stage && subStatuses.length > 0) {
                    subStatuses.forEach(({ value, label }, _, self) => {
                      if (
                        [3, 4, 12, 14].includes(parseInt(caseObj.sub_stage))
                      ) {
                        substage = self[2]?.label;
                      } else {
                        if (parseInt(caseObj.sub_stage) === value)
                          substage = label;
                      }
                    });
                  }

                  return (
                    <tr
                      key={index}
                      className={`${
                        index % 2 === 0 ? "light_row odd" : "even"
                      }`}
                    >
                      <td>
                        {getLeadIdHtml(
                          caseObj,
                          user,
                          tabData.caseData[0].newProductType,
                        )}
                      </td>

                      {[0, 4, 6, 7].includes(activeTab) && (
                        <td>
                          {raised_date}
                          {time_lapsed}
                        </td>
                      )}

                      <td>
                        {(() => {
                          let requestedDate = "--";
                          if ([0, 1, 2, 3, 4, 6, 7].includes(activeTab)) {
                            if (
                              caseObj.is_prepayment_raised &&
                              caseObj.is_prepayment_raised === 1
                            ) {
                              requestedDate = !caseObj.payment_raised_date
                                ? "--"
                                : caseObj.payment_raised_date;
                            } else {
                              requestedDate = !caseObj.payment_request_date
                                ? "--"
                                : caseObj.payment_request_date;
                            }
                          } else if (activeTab === 5) {
                            requestedDate = !caseObj.disbursed_date
                              ? "--"
                              : caseObj.disbursed_date;
                          }
                          return requestedDate === "--"
                            ? "--"
                            : activeTab === 5
                              ? convertToUTCFormat(
                                  parseISO(requestedDate),
                                  "dd-MM-yyyy kk:mm:ss",
                                )
                              : convertToUTCFormat(
                                  parseISO(requestedDate),
                                  "dd-MM-yyyy",
                                );
                        })()}
                      </td>

                      <td>
                        <div className="clearfix font-14 col-black line-hit-24">
                          {`${
                            !caseObj.customer_name ? "-" : caseObj.customer_name
                          } ${!caseObj.last_name ? "-" : caseObj.last_name}`}
                        </div>
                        {!caseObj.mobile ? "--" : caseObj.mobile}
                      </td>

                      <td>
                        <div className="clearfix font-14 col-black line-hit-24">
                          {!caseObj.dealer_name ? "--" : caseObj.dealer_name}
                        </div>
                        <div className="clearfix line-hit-20">
                          {!caseObj.dealer_mobile
                            ? "--"
                            : caseObj.dealer_mobile}
                        </div>
                      </td>

                      {activeTab === 0 &&
                      caseObj.hasOwnProperty("payee_type") ? (
                        <td>{caseObj.payee_type}</td>
                      ) : (
                        <></>
                      )}

                      <td>{!caseObj.lead_city ? "--" : caseObj.lead_city}</td>

                      {activeTab !== 5 && (
                        <td>
                          <div>
                            <span
                              className={`label font-12 ${statusCls} status-col`}
                            >
                              {stage}
                            </span>
                          </div>
                        </td>
                      )}

                      {activeTab !== 5 && (
                        <td>
                          <div>
                            <span
                              className={`label font-12 ${substatusCls} substatus-col`}
                            >
                              {substage}
                            </span>
                          </div>
                        </td>
                      )}

                      {activeTab === 2 && (
                        <td>
                          {!caseObj.dts_bal_amt ? "--" : caseObj.dts_bal_amt}
                        </td>
                      )}

                      {(() => {
                        const makerName = !caseObj.maker_name
                          ? "--"
                          : caseObj.maker_name;
                        if ([3, 4, 6].includes(activeTab)) {
                          if (
                            state.typeAssignButton === 1 &&
                            (activeTab === 6 ||
                              ([3, 4].includes(activeTab) &&
                                substage === "Discrepancy Identified"))
                          ) {
                            const assigneeList = [
                              {
                                text:
                                  [3, 4].includes(activeTab) || caseObj.id
                                    ? "Reassign To"
                                    : "Assign To",
                                value: "0",
                              },
                              ...state.assigneeList,
                            ];
                            let preSelected = assigneeList.find(
                              (assignees) => assignees.text === makerName,
                            );
                            preSelected = preSelected ? preSelected.value : "0";
                            return (
                              <td>
                                <div
                                  id={`edit_assign_box${caseObj.id}`}
                                  style={{ display: "block" }}
                                >
                                  <SingleSelectDropDown
                                    dataArr={assigneeList}
                                    handleChange={(e) =>
                                      handleAssigneeChange(
                                        e,
                                        caseObj.lead_id,
                                        caseObj.id,
                                        caseObj.fcm_bank_id,
                                        caseObj.bank_disbursed_amount,
                                        3,
                                      )
                                    }
                                    name={`maker_id${caseObj.lead_id}`}
                                    disabled={false}
                                    required={false}
                                    value={
                                      state.selectedAssigneeList[
                                        caseObj.lead_id
                                      ]
                                        ? state.selectedAssigneeList[
                                            caseObj.lead_id
                                          ]
                                        : preSelected
                                    }
                                    divClassName="form-group mb-0"
                                  />
                                </div>
                              </td>
                            );
                          } else if (state.typeAssignButton === 2) {
                            return <td>{makerName}</td>;
                          } else {
                            return (
                              <td>
                                {[3, 4].includes(activeTab) ? makerName : "--"}
                              </td>
                            );
                          }
                        }
                      })()}

                      {[0, 1, 6, 7].includes(activeTab) && (
                        <td>{`${payment_type} \n ${
                          [1, 7].includes(activeTab) ? "" : tranches
                        }`}</td>
                      )}

                      {activeTab === 0 ? (
                        <td>
                          {!caseObj.maker_name ? "--" : caseObj.maker_name}
                        </td>
                      ) : (
                        ""
                      )}

                      {(() => {
                        if (activeTab === 1) {
                          if (state.typeAssignButton === 1) {
                            return (
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-xs"
                                  onClick={() =>
                                    assignOrReassignMaker(
                                      caseObj.lead_id,
                                      caseObj.id,
                                      caseObj.fcm_bank_id,
                                      caseObj.bank_disbursed_amount,
                                      user.id,
                                    )
                                  }
                                >
                                  Assign to me
                                </button>
                              </td>
                            );
                          } else if (state.typeAssignButton === 2) {
                            const assigneeList = [
                              {
                                text: !caseObj.id ? "Assign To" : "Reassign To",
                                value: "",
                              },
                              ...state.assigneeList,
                            ];
                            return (
                              <td>
                                <div
                                  id={`edit_assign_box${caseObj.id}`}
                                  style={{ display: "block" }}
                                >
                                  <SingleSelectDropDown
                                    dataArr={assigneeList}
                                    handleChange={(e) =>
                                      handleAssigneeChange(
                                        e,
                                        caseObj.lead_id,
                                        caseObj.id,
                                        caseObj.fcm_bank_id,
                                        caseObj.bank_disbursed_amount,
                                      )
                                    }
                                    name={`maker_id${caseObj.lead_id}`}
                                    disabled={false}
                                    required={false}
                                    value={
                                      state.selectedAssigneeList[
                                        caseObj.lead_id
                                      ]
                                        ? state.selectedAssigneeList[
                                            caseObj.lead_id
                                          ]
                                        : ""
                                    }
                                    divClassName="form-group mb-0"
                                  />
                                </div>
                              </td>
                            );
                          } else {
                            return "--";
                          }
                        } else if (activeTab === 7) {
                          if (state.typeAssignButton === 1) {
                            return (
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-xs"
                                  onClick={() =>
                                    assignPaylead(
                                      caseObj.lead_id,
                                      caseObj.id,
                                      caseObj.dts_pay_count,
                                      caseObj.customer_name,
                                      caseObj.last_name,
                                      caseObj.regno,
                                      user.id,
                                    )
                                  }
                                >
                                  Assign to me
                                </button>
                              </td>
                            );
                          } else {
                            return "--";
                          }
                        }
                      })()}

                      {(() => {
                        if (activeTab === 3 || activeTab === 4) {
                          if (
                            caseObj.showPayleadReassignment &&
                            state.payleadAssignButton === 1
                          ) {
                            const payHeadName = caseObj.pay_head_name
                              ? caseObj.pay_head_name
                              : "";
                            const payleadAssigneeList = [
                              {
                                text: payHeadName ? "Reassign To" : "Assign To",
                                value: "0",
                              },
                              ...state.payleadAssigneeList,
                            ];
                            let preSelected = payleadAssigneeList.find(
                              (assignees) => assignees.text === payHeadName,
                            );
                            preSelected = preSelected ? preSelected.value : "0";
                            return (
                              <td>
                                <div
                                  id={`edit_assign_box${caseObj.id}`}
                                  style={{ display: "block" }}
                                >
                                  <SingleSelectDropDown
                                    dataArr={payleadAssigneeList}
                                    handleChange={(e) =>
                                      handlePayleadAssigneeChange(
                                        e,
                                        caseObj.lead_id,
                                        caseObj.id,
                                        caseObj.dts_pay_count,
                                        caseObj.customer_name,
                                        caseObj.last_name,
                                        caseObj.regno,
                                        payHeadName
                                          ? "reAssignPaylead"
                                          : "assignPaylead",
                                      )
                                    }
                                    name={`paylead_id${caseObj.lead_id}`}
                                    disabled={false}
                                    required={false}
                                    value={
                                      state.selectedPayleadAssigneeList[
                                        caseObj.lead_id
                                      ]
                                        ? state.selectedPayleadAssigneeList[
                                            caseObj.lead_id
                                          ]
                                        : preSelected
                                    }
                                    divClassName="form-group mb-0"
                                  />
                                </div>
                              </td>
                            );
                          } else {
                            return (
                              <td>
                                {!caseObj.pay_head_name
                                  ? "--"
                                  : caseObj.pay_head_name}
                              </td>
                            );
                          }
                        }
                      })()}

                      {[2, 3, 4].includes(activeTab) && (
                        <td>{!caseObj.hod_name ? "--" : caseObj.hod_name}</td>
                      )}

                      {(() => {
                        if (activeTab === 2) {
                          if (state.typeAssignButton === 1) {
                            return (
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-xs"
                                  onClick={() =>
                                    assignOrReassignMaker(
                                      caseObj.lead_id,
                                      caseObj.id,
                                      caseObj.fcm_bank_id,
                                      caseObj.bank_disbursed_amount,
                                      user.id,
                                      2,
                                    )
                                  }
                                >
                                  Assign to me
                                </button>
                              </td>
                            );
                          } else if (state.typeAssignButton === 2) {
                            const assigneeList = [
                              {
                                text: "Reassign To",
                                value: "",
                              },
                              ...state.assigneeList,
                            ];
                            return (
                              <td>
                                <div
                                  id={`edit_assign_box${caseObj.id}`}
                                  style={{ display: "block" }}
                                >
                                  <SingleSelectDropDown
                                    dataArr={assigneeList}
                                    handleChange={(e) =>
                                      handleAssigneeChange(
                                        e,
                                        caseObj.lead_id,
                                        caseObj.id,
                                        caseObj.fcm_bank_id,
                                        caseObj.bank_disbursed_amount,
                                        2,
                                      )
                                    }
                                    name={`maker_id${caseObj.lead_id}`}
                                    disabled={false}
                                    required={false}
                                    value={
                                      state.selectedAssigneeList[
                                        caseObj.lead_id
                                      ]
                                        ? state.selectedAssigneeList[
                                            caseObj.lead_id
                                          ]
                                        : ""
                                    }
                                    divClassName="form-group mb-0"
                                  />
                                </div>
                              </td>
                            );
                          } else {
                            return "--";
                          }
                        }
                      })()}

                      {activeTab === 5 && (
                        <td>
                          {!caseObj.bank_disbursed_amount
                            ? "--"
                            : formatAmount(caseObj.bank_disbursed_amount)}
                        </td>
                      )}

                      {activeTab === 5 && (
                        <td>
                          {(!caseObj.ire_policy_name
                            ? ""
                            : caseObj.ire_policy_name) +
                            (!caseObj.bank_name ? "--" : caseObj.bank_name)}
                        </td>
                      )}

                      {activeTab === 5 && (
                        <td>
                          {!caseObj.bank_los_id ? "--" : caseObj.bank_los_id}
                        </td>
                      )}
                      {activeTab === 5 && (
                        <td>{!caseObj.loanType ? "--" : caseObj.loanType}</td>
                      )}

                      <td>
                        <div className="btn-group">
                          <Link
                            to={`/payments/details?lead_id=${btoa(
                              caseObj.lead_id,
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-default btn-xs listing-action"
                          >
                            <span
                              className="fa fa-eye"
                              aria-hidden="true"
                            ></span>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </thead>
            </table>
            <PaginationButtons
              page={page}
              total={tabData.total}
              prevPage={prevPage}
              nextPage={nextPage}
              pageSelected={pageSelected}
            />
          </div>
        </div>
      </div>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.tabData === nextProps.tabData;
  },
);

export default Table;
